import React, { useState, useRef, useEffect } from "react";
import "../../AccountReports/SchemeReports/SchemeReportDia.css";
import ssLogo from "../../../assets/images/sslogo.png";
import close from "../../../assets/images/close.png";
import ComboBox from "../../ComboBoxes/ComboBox";
import axios from "axios";
import headeLogo from "../../../assets/images/shersoftnavLogo.png";
import { useDbContext } from "../../../context/DbContext";
import { DatePicker, Space } from "antd";
import moment from "moment";
import { ClipLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { selectActiveFyid } from "../../../app/financialYearSlice";
import { selectActiveLocation } from "../../../app/locationSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";

function TransferVoucher({ fId, onClose, tvoucherName }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const activeFyid = useSelector(selectActiveFyid);
  const activeLocation = useSelector(selectActiveLocation);
  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId")) || 0;
  const locationId = activeLocation?.id || Number(sessionStorage.getItem("loginLocationId")) || Number(localStorage.getItem("loginLocationId")) || 0;
  const [voucherName, setvoucherName] = useState("Scheme Receipt Order");

  const [expanded, setExpanded] = useState(false);
  const [forms, setForms] = useState([]);
  const [formoptions, setformoptions] = useState([]);

  //////console.log("forms=", forms);

  const [TransferfId, setTransferfId] = useState([]);
  //////console.log("TransferfId=", TransferfId);

  const [selectedForms, setSelectedForms] = useState([]);
  //////console.log("selectedFormsforms=", selectedForms);

  const [contentVisible, setContentVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const voucherRef = useRef(null);
  const cashaccRef = useRef(null);

  const transferRef = useRef(null);
  const tableContainerRef = useRef(null);
  const { minDate, maxDate, validateAndAlert, isDateInFy } = useActiveFyLimits();
  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to active FY limits
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };
  const initialDateVal = getCurrentDate();
  const [ReportData, setReportData] = useState({
    fromDate: initialDateVal,
    toDate: initialDateVal,
    reportType: "TransferReport",
    voucherName: voucherName,
    agent: "",
    customer: "",
    mobileNo: "",
    accno: "",
  });
  const [cashAccopt, setcashAccopt] = useState([]);
  const [selectedcashAcc, setselectedcashAcc] = useState("");
  const [voucher, setvoucher] = useState("");
  //////console.log("voucher=", voucher);

  //////console.log("selectedcashAcc==", selectedcashAcc);

  const selectcashAcc = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_caba/${dbCode}`
      );

      const caba = response.data;

      // Filter only items where LedName is 'CASH'
      const filteredData = caba
        // .filter((item) => item.LedName === "CASH")
        .map((item) => [item.ledcode, item.LedName]);

      setcashAccopt(filteredData);
    } catch (error) {
      console.error("Error fetching selectcashAcc Values:", error.message);
    }
  };
  ////////console.log("cashAccopt==", cashAccopt);

  useEffect(() => {
    selectcashAcc();
  }, [apiBaseUrl]);
  const [visibleColumns, setVisibleColumns] = useState({
    accNo: true,
    customer: true,
    entryNo: true,
    type: true,
    amount: true,
    disc: true,
    total: true,
    gm: true,
    discGm: true,
    totalGm: true,
    agent: true,
    date: true,
    schemeName: true,
  });

  const spinnerProps = {
    color: "#026CC3",
    height: 12,
    width: 5,
    radius: 1,
    margin: 3,
    size: 30,
    speedMultiplier: 0.8,
    css: {
      opacity: "0.8",
    },
  };

  useEffect(() => {
    fetchAllformDatas();
  }, []);

  const fetchAllformDatas = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/selectAllformDatas/${dbCode}`
      );
      const Res = response.data;
      const fData = Res.map((item) => ({
        id: item.fmrEntryNo,
        name: item.fmrAbbreviation,
      }));

      const cData = Res.map((item) => [item.fmrEntryNo, item.fmrAbbreviation]);

      setformoptions(cData);
      setForms(fData);
    } catch (error) {
      console.error("Error fetching Purchase forms Values:", error.message);
    }
  };

  const handleToggle = () => {
    if (expanded) {
      setContentVisible(true);
      setExpanded(false);
    } else {
      setContentVisible(false);
      setTimeout(() => setExpanded(true), 300);
    }
  };

  const handleFormSelect = (formId, isChecked) => {
    if (isChecked) {
      setSelectedForms([...selectedForms, formId]);
    } else {
      setSelectedForms(selectedForms.filter((id) => id !== formId));
    }
  };

  const handleSelectAll = () => {
    setSelectedForms(forms.map((form) => form.id));
  };

  const handleUnselectAll = () => {
    setSelectedForms([]);
  };

  const fetchData = async () => {
    if (!(ReportData.voucherName.length > 0)) {
      alert("Invalid Voucher");
      return;
    }

    try {
      setIsLoading(true);
      const requestPayload = {
        reportData: { ...ReportData, fyid: fyid, Location: locationId },
        forms: selectedForms,
      };
      const response = await axios.post(
        `${apiBaseUrl}/main/Schrepsimple/${dbCode}`,
        requestPayload
      );
      setTableData(response.data);
      setSelectedRows([]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(index)
        ? prevSelected.filter((i) => i !== index)
        : [...prevSelected, index]
    );
  };

  const selectAllRows = () => {
    setSelectedRows(tableData.map((_, index) => index));
  };

  const clearAllRows = () => {
    setSelectedRows([]);
  };

  // Add these state variables at the top of your component
  const [isTransferring, setIsTransferring] = useState(false);
  const [transferredEntries, setTransferredEntries] = useState([]);

  // Modified handleTransfer function
  const handleTransfer = async () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one row to transfer");
      return;
    }

    if (selectedForms.length === 0) {
      alert("Please select at least one form");
      return;
    }

    if (
      !Array.isArray(TransferfId) ||
      !TransferfId ||
      TransferfId.length === 0
    ) {
      alert("Please select a form to transfer to");
      return;
    }

    if (!window.confirm("Are you sure you want to transfer the selected receipt(s)?")) {
      return;
    }

    if (isLoading || isTransferring) {
      return;
    }

    try {
      setIsTransferring(true);
      setIsLoading(true);

      // Get selected rows data
      const selectedData = tableData.filter((_, index) =>
        selectedRows.includes(index)
      );

      // Check for already transferred entries
      const newEntries = selectedData.filter(
        (row) => !transferredEntries.includes(row.Entry_No)
      );

      if (newEntries.length !== selectedData.length) {
        const duplicateCount = selectedData.length - newEntries.length;
        if (
          !window.confirm(
            `${duplicateCount} entries have already been transferred. Continue with the remaining ${newEntries.length} entries?`
          )
        ) {
          return;
        }
      }

      const formatDateForSQL = (dateString) => {
        if (!dateString) return getCurrentDate();
        const parts = dateString.split("-");
        if (parts.length === 3) {
          // If date is in DD-MM-YYYY format, convert to YYYY-MM-DD
          if (parts[0].length === 2 && parts[2].length === 4) {
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
          // If date is already in YYYY-MM-DD format, return as-is
          if (parts[0].length === 4) {
            return dateString;
          }
        }
        // Fallback to current date if format is unrecognized
        return getCurrentDate();
      };

      // Prepare receipts data - only for new entries
      const receiptsData = newEntries.map((row) => ({
        statementType: "SchRec_insert",
        cashacc: Array.isArray(selectedcashAcc)
          ? selectedcashAcc[0]
          : row.CashACC,
        schemeId: row.SchemeId || 0,
        rate: row.Rate || 0,
        date: formatDateForSQL(row.Date),
        salesMan: 0,
        totalamount: row.Amount,
        totalDisc: row.Disc || 0,
        totalamtdisc: row.Total || row.Amount,
        totalgm: row.Gm || 0,
        totaldiscgm: row.DiscGm || 0,
        agCode: 0,
        formId: TransferfId[0],
        fyid: fyid,
        Location: locationId,
        type: [
          {
            SINo: 1,
            name: row.LedCode,
            agent: row.AgentId,
            accountNumber: row.SchId,
            amount: row.Amount,
            discount: row.Disc || 0,
            total: row.Total || row.Amount,
            gm: row.Gm || 0,
            discGm: row.DiscGm || 0,
            totalGm: row.TotalGm || row.Gm || 0,
            narration: `Transferred from ${
              row.Entry_No
            } on ${getCurrentDate()}`,
            printgm: 1,
            billed: 1,
            schemeId: row.SchemeId
          },
        ],
      }));

      // Save all receipts
      const savePromises = receiptsData.map((receipt) =>
        axios.post(`${apiBaseUrl}/main/saveSchRec/${dbCode}`, receipt)
      );

      const responses = await Promise.all(savePromises);

      // Check if all saves were successful
      const allSuccess = responses.every((response) => response.data.success);

      if (allSuccess) {
        // Update transferred entries list
        const newTransferredEntries = newEntries.map((row) => row.Entry_No);
        setTransferredEntries([
          ...transferredEntries,
          ...newTransferredEntries,
        ]);

        // Update the original receipts status
        const receiptsToUpdate = newEntries.map((row) => ({
          entryNo: row.Entry_No,
          formId: row.FormID,
          ledcode: row.LedCode,
        }));

        const updatePromises = receiptsToUpdate.map((receipt) =>
          axios.post(`${apiBaseUrl}/main/updateSchReceipt/${dbCode}`, {
            statementType: "updatereceiptsonly",
            entryNo: receipt.entryNo,
            frmid: receipt.formId,
            ledcode: receipt.ledcode,
            fyid: fyid,
            Location: locationId,
          })
        );

        await Promise.all(updatePromises);

        alert(`${newEntries.length} receipts transferred successfully!`);

        // Refresh the data
        await fetchData();
        setSelectedRows([]);
      } else {
        alert("Some receipts failed to transfer!");
        console.error("Server responses:", responses);
      }
    } catch (error) {
      console.error("Error transferring receipts:", error);
      alert("Error transferring receipts!");
    } finally {
      setIsTransferring(false);
      setIsLoading(false);
    }
  };

  const renderForms = () => {
    const formGroups = [];
    for (let i = 0; i < forms.length; i += 2) {
      formGroups.push(
        <div key={i} className="w-full flex justify-between mb-2">
          {forms[i] && (
            <div className="w-[48%] flex items-center gap-1">
              <input
                type="checkbox"
                id={`form-${forms[i].id}`}
                checked={selectedForms.includes(forms[i].id)}
                onChange={(e) =>
                  handleFormSelect(forms[i].id, e.target.checked)
                }
                className="h-3 w-3"
              />
              <label
                htmlFor={`form-${forms[i].id}`}
                className="text-xs text-black font-Poppins whitespace-nowrap"
              >
                {forms[i].name}
              </label>
            </div>
          )}
          {forms[i + 1] && (
            <div className="w-[48%] flex items-center gap-1">
              <input
                type="checkbox"
                id={`form-${forms[i + 1].id}`}
                checked={selectedForms.includes(forms[i + 1].id)}
                onChange={(e) =>
                  handleFormSelect(forms[i + 1].id, e.target.checked)
                }
                className="h-3 w-3"
              />
              <label
                htmlFor={`form-${forms[i + 1].id}`}
                className="text-xs text-black font-Poppins whitespace-nowrap"
              >
                {forms[i + 1].name}
              </label>
            </div>
          )}
        </div>
      );
    }
    return formGroups;
  };

  return (
    <div className="bg-[#026CC3] font-Inter w-full h-full rounded-lg shadow-md flex flex-col items-center absolute transition-all duration-300 z-50">
      <style>
        {`
          .tfborder {
            border: 1px solid #d3d1d1;
          }

          .tfborderblack {
            box-sizing: border-box;
            border: 1px solid rgb(18, 59, 105);
          }

          @keyframes fade-in {
            from {
              opacity: 0;
              transform: scale(0.97);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          .animate-fade-in {
            animation: fade-in 0.3s ease-in-out;
          }

          .content-transition {
            transition: opacity 0.3s ease-in-out;
          }
       
        `}
      </style>

      {/* Header */}
      <div className="w-full h-[7.5%] flex rounded-t-lg py-1">
        <div className="w-1/2 h-full flex items-center gap-1 pl-2">
          <img src={headeLogo} alt="SS" />
          <label className="pl-2 text-sm font-medium text-white font-Poppins">
            Transfer Pv
          </label>
        </div>
        <div className="w-1/2 h-full flex justify-end items-center gap-2 pr-2">
          <button
            className="rounded px-2 py-1 bg-red-500 border-none h-[25px] w-[25px] flex justify-center items-center"
            onClick={onClose}
          >
            <img src={close} alt="X" className="h-[13px] w-[13px]" />
          </button>
        </div>
      </div>

      <div className="w-full h-full flex bg-white rounded-b-lg items-center justify-center box-border p-4">
        <div className="w-full h-full flex gap-1 transition-all duration-500 ease-in-out">
          {/* Left Section */}
          <div
            className={`transition-all duration-500 ease-in-out tfborder h-full overflow-hidden ${
              expanded ? "w-0" : "w-[40%]"
            }`}
          >
            <div
              className={`w-full h-full flex flex-col box-border py-5 px-2 gap-3 content-transition ${
                contentVisible ? "opacity-100" : "opacity-0"
              }`}
            >
              {/* Inputs Section */}
              <div className="w-full h-auto flex flex-col">
                <div className="w-full h-[30px] flex items-center ">
                  <div className="w-full h-full flex gap-[2%] items-center justify-center">
                    <label
                      htmlFor="from"
                      className="w-[15%] text-black font-Poppins text-[9.39px] font-medium leading-[14px] text-left"
                    >
                      From
                    </label>
                    <div className="w-[83%] h-full flex  justify-between ">
                      <input
                        id="from"
                        type="date"
                        min={minDate}
                        max={maxDate}
                        className="w-[40%] h-[24px] tfborder rounded-none text-sm p-0 m-0"
                        value={ReportData.fromDate}
                        onChange={(e) => {
                          setReportData({
                            ...ReportData,
                            fromDate: e.target.value,
                          });
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          if (val && !isDateInFy(val)) {
                            alert("Date incompatible with financial year");
                          }
                        }}
                      />

                      <label
                        htmlFor="to"
                        className="h-full  text-black font-Poppins text-[9.39px] font-medium leading-[14px] text-center w-full flex items-center justify-center"
                      >
                        To
                      </label>
                      <input
                        id="to"
                        type="date"
                        min={minDate}
                        max={maxDate}
                        className="w-[40%]  h-[24px] tfborder rounded-none text-sm p-0 m-0"
                        value={ReportData.toDate}
                        onChange={(e) => {
                          setReportData({
                            ...ReportData,
                            toDate: e.target.value,
                          });
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          if (val && !isDateInFy(val)) {
                            alert("Date incompatible with financial year");
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full h-[30px] flex items-center gap-[2%]">
                  <label
                    htmlFor=""
                    className="w-[15%] text-black font-Poppins text-[9.39px] font-medium leading-[14px] text-left"
                  >
                    Voucher
                  </label>
                  <ComboBox
                    comboRef={voucherRef}
                    options={[]}
                    findedValue={voucherName}
                    inputClassName="tfborder"
                    className="h-[24px] w-[83%]"
                    // onInputChange={(e) => setvoucher(e)}
                    readOnly
                  />
                </div>
              </div>

              {/* Form Selection Section */}
              <div className="w-full h-2/5 flex flex-col rounded-md">
                <div className="rounded-t-md h-[40px] bg-[#026CC3] box-border px-2 text-white font-poppins text-xs font-bold leading-normal tracking-normal text-left flex items-center">
                  Select Form
                </div>
                <div className="h-full box-border px-2 py-2 bg-[#F8F8F8] overflow-y-auto">
                  {renderForms()}
                </div>
                <div className="rounded-b-md h-[60px] bg-[#F8F8F8] box-border px-2 text-white font-poppins text-xs font-bold leading-normal tracking-normal text-left flex items-center justify-center gap-4">
                  <button
                    className="w-1/2 h-[24px] flex items-center justify-center rounded-sm text-black font-poppins text-xs font-medium leading-normal tracking-normal tfborderblack"
                    onClick={handleSelectAll}
                  >
                    Select All
                  </button>
                  <button
                    className="w-1/2 h-[24px] flex items-center justify-center rounded-sm text-black font-poppins text-xs font-medium leading-normal tracking-normal tfborderblack"
                    onClick={handleUnselectAll}
                  >
                    UnSelect
                  </button>
                </div>
              </div>
              <div className="w-full h-[35px] flex items-center gap-[2%]">
                <label
                  htmlFor=""
                  className="w-[15%] whitespace-nowrap text-black font-Poppins text-[9.39px] font-medium leading-[14px] text-left"
                >
                  CASH A/C
                </label>
                <ComboBox
                  comboRef={cashaccRef}
                  options={cashAccopt}
                  findedValue={
                    Array.isArray(selectedcashAcc)
                      ? selectedcashAcc[1]
                      : selectedcashAcc
                  }
                  inputClassName="tfborder"
                  className="h-[24px] w-[83%]"
                  onInputChange={(e) => setselectedcashAcc(e)}
                />
              </div>
              {/* Transfer Section */}
              <div className="w-full h-[35px] flex items-center gap-[2%] ">
                <label
                  htmlFor=""
                  className="w-[15%] whitespace-nowrap text-black font-Poppins text-[9.39px] font-medium leading-[14px] text-left"
                >
                  Transfer To
                </label>
                <ComboBox
                  comboRef={transferRef}
                  options={formoptions}
                  inputClassName="tfborder"
                  className="h-[24px] w-[83%]"
                  findedValue={
                    Array.isArray(TransferfId) ? TransferfId[1] : TransferfId
                  }
                  onInputChange={(e) => setTransferfId(e)}
                />
              </div>

              {/* Action Buttons */}
              <div className="w-full h-1/5 flex items-center justify-center box-border px-2 gap-4">
                <button
                  className="w-1/2 h-[33px] flex items-center justify-center bg-[#026CC3] rounded-sm text-white font-poppins text-xs font-medium leading-normal tracking-normal border-none"
                  onClick={() => {
                    fetchData();
                    handleToggle();
                  }}
                >
                  Show
                </button>
                <button
                  className="w-1/2 h-[33px] flex items-center justify-center bg-[#026CC3] rounded-sm text-white font-poppins text-xs font-medium leading-normal tracking-normal border-none"
                  onClick={handleTransfer}
                  disabled={isLoading || isTransferring}
                >
                  {isTransferring ? "Transferring..." : "Transfer"}
                </button>
              </div>
            </div>
          </div>

          {/* Toggle Button */}
          <div
            onClick={() => {
              fetchData();
              handleToggle();
            }}
            className="w-[5%] h-full bg-[#026CC3] flex items-center justify-center text-white font-poppins text-[9.39px] font-bold leading-[14px] tracking-normal cursor-pointer hover:bg-[#0359a4] transition-colors rounded-sm"
          >
            SHOW
          </div>

          {/* Right Section */}
          <div
            className={`transition-all duration-500 ease-in-out h-full box-border p-3 tfborder ${
              expanded ? "w-[95%]" : "w-[54%]"
            }`}
          >
            {/* Table */}
            <div className="w-full h-full flex flex-col bg-[#D4D4D4]">
              {isLoading ? (
                <div className="flex justify-center items-center h-full w-full">
                  <ClipLoader {...spinnerProps} />
                </div>
              ) : (
                <div
                  className="w-full h-[95%] flex-shrink-0 flex flex-col text-black text-[10px] font-semibold leading-normal overflow-auto"
                  ref={tableContainerRef}
                >
                  <table className="w-full">
                    <thead className="w-full bg-[rgb(2,108,195)] h-[30px] sticky top-0 z-10">
                      <tr className="whitespace-nowrap text-center">
                        <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                          <input
                            type="checkbox"
                            checked={
                              selectedRows.length === tableData.length &&
                              tableData.length > 0
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                selectAllRows();
                              } else {
                                clearAllRows();
                              }
                            }}
                          />
                        </th>
                        {visibleColumns.date && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Date
                          </th>
                        )}
                        {visibleColumns.schemeName && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Scheme Name
                          </th>
                        )}
                        {visibleColumns.accNo && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            A/C No
                          </th>
                        )}
                        {visibleColumns.customer && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Customer
                          </th>
                        )}
                        {visibleColumns.entryNo && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Entry No
                          </th>
                        )}
                        {visibleColumns.type && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Type
                          </th>
                        )}
                        {visibleColumns.amount && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Amount
                          </th>
                        )}
                        {visibleColumns.disc && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Discount
                          </th>
                        )}
                        {visibleColumns.total && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Total
                          </th>
                        )}
                        {visibleColumns.gm && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Gm
                          </th>
                        )}
                        {visibleColumns.discGm && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Disc Gm
                          </th>
                        )}
                        {visibleColumns.totalGm && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Total Gm
                          </th>
                        )}
                        {visibleColumns.agent && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Agent
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((rowData, rowIndex) => (
                        <tr
                          key={rowIndex}
                          className={`px-1 h-[28px] text-[10px]  ${
                            rowData.atType === "Sub Total"
                              ? "text-red-500"
                              : rowData.atType === "Total"
                              ? "text-blue-500"
                              : selectedRows.includes(rowIndex)
                              ? "bg-blue-200"
                              : ""
                          }`}
                          onClick={() => toggleRowSelection(rowIndex)}
                        >
                          <td className=" border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee]  ">
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(rowIndex)}
                              onChange={(e) => {
                                e.stopPropagation();
                                toggleRowSelection(rowIndex);
                              }}
                              onClick={() => toggleRowSelection(rowIndex)}
                            />
                          </td>
                          {visibleColumns.date && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] whitespace-nowrap text-center">
                              {rowData.Date}
                            </td>
                          )}
                          {visibleColumns.schemeName && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 w-[8vw]">
                              {rowData.SchemeName}
                            </td>
                          )}
                          {visibleColumns.accNo && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[5vw]">
                              {rowData.ACC_No}
                            </td>
                          )}
                          {visibleColumns.customer && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 w-[8vw]">
                              {rowData.Name}
                            </td>
                          )}
                          {visibleColumns.entryNo && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] whitespace-nowrap text-center px-1 w-[2vw]">
                              {rowData.Entry_No}-
                              {rowData.Agent
                                ? rowData.Agent.substring(0, 3)
                                : ""}
                            </td>
                          )}
                          {visibleColumns.type && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] whitespace-nowrap px-1 w-[8vw]">
                              {rowData.Type}
                            </td>
                          )}
                          {visibleColumns.amount && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[8vw]">
                              {rowData.Amount}
                            </td>
                          )}
                          {visibleColumns.disc && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[8vw]">
                              {rowData.Disc}
                            </td>
                          )}
                          {visibleColumns.total && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[8vw]">
                              {rowData.Total}
                            </td>
                          )}
                          {visibleColumns.gm && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[8vw]">
                              {rowData.Gm}
                            </td>
                          )}
                          {visibleColumns.discGm && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[8vw]">
                              {rowData.DiscGm}
                            </td>
                          )}
                          {visibleColumns.totalGm && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[8vw]">
                              {rowData.TotalGm}
                            </td>
                          )}
                          {visibleColumns.agent && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 w-[8vw]">
                              {rowData.Agent}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransferVoucher;
